import { loadAndExecute } from './elements/share-teams';
const fn_apply_zoom = (s = 0) => {
  const zoom = Math.max(10, Math.min(parseInt(localStorage.getItem("zoom") ?? 16) + s, 22));
  localStorage.setItem("zoom", zoom);
  document.querySelector("html").style.fontSize = zoom === 16 ? "" : `${zoom}px`;
};

document.addEventListener(
  "DOMContentLoaded",
  () => {
    fn_apply_zoom();

    document
      .querySelectorAll('[data-function="print"]')
      .forEach((e) => e.addEventListener("click", () => window.print()));

    document
      .querySelectorAll('[data-function="zoom-in"]')
      .forEach((e) => e.addEventListener("click", () => fn_apply_zoom(2)));

    document
      .querySelectorAll('[data-function="zoom-out"]')
      .forEach((e) => e.addEventListener("click", () => fn_apply_zoom(-2)));

    document
      .querySelectorAll('[data-function="share-teams"]')
      .forEach((e) => e.addEventListener("click", () => loadAndExecute()));
  },
  { passive: true }
);
